import app, { Component } from 'apprun';
import { users as usersApi, locations, companies } from './api';
import { showSaveStatusMessage, lookup_en, isStringEqual } from './utils';
import UserTerminate from './user-terminate';
import UserReactivate from './user-reactivate';

import PropEditorTextComponent from './common-props/common-props-text-edit';
import PropEditorSelectionComponent from './common-props/common-props-selection-edit';
import PropEditorRegionsComponent from './common-props/common-props-regions-edit';
import PropEditorDateComponent from './common-props/common-props-date-edit';

import PropEditorExpertTopicComponent from './common-props/common-props-expertTopic-edit';
import UserPropertyPhoneComponent from './user-props/user-props-phone';
import UserPropertySocNetComponent from './user-props/user-props-socialNetworking';
import UserPropertyAwardComponent from './user-props/user-props-award';
import UserPropertyPhotoComponent from './user-props/user-props-photo';
import UserPropertyPasswordComponent from './user-props/user-props-password-edit';
import UserPropertySpecialityComponent from './user-props/user-props-speciality';
import UserPropertycommercialComponent from './user-props/user-props-commercial';
import UserPropertyFeeExceptionComponent from './user-props/user-props-exception';
import UserPropertyTeamDateComponent from './user-props/user-props-TeamDate-edit';
import UserPropertyDateComponent from './user-props/user-props-date-edit';
import UserPropertyAuditLogComponent from './user-props/user-props-audit-log';
import UserPropertyIreOverrideComponent from './user-props/user-props-ire-overrides';
import UserPropertyProtectionRoyaleComponent from './user-props/user-props-protection-royale';
import UserPropertySpeakerEventComponent from './user-props/user-props-speakerevent';
import UserPropertyUsernameComponent from './user-props/user-props-username-edit';

import moment from 'moment';

const idFieldName = 'personId';
const getPropItem = (state, fieldName) => state.props.find(p => p.fieldName === fieldName);

function getItemValue(item) {
  if (!item) {return;}
  let itemValue = item.value;
  let selectOptions;
  switch (item.fieldType) {
  case null:
  case 'CommProg':
  case 'CALL':
  case 'Text':
    return itemValue;
  case 'Phones':
  case 'html':
    return item.value
      ? item.value.split('<BR/>').map(p => (
        <span>
          {p}
          <br />
        </span>
      ))
      : '';
  case 'TMDateStr':
    return item.value;
  case 'DateStr':
    return item.value;
    //return (item.value) ? new Date(item.value).toDateString() : null;
  case 'Int':
    if (itemValue === '-1' && item.fieldTypeDetail) {itemValue = 'Not Available';}
    return itemValue;
  case 'Specialty':
    const speciality = JSON.parse(itemValue || '{"AttributeID":"","EffectiveDate":"","ExpirationDate":""}');
    itemValue = speciality.AttributeID;
    // TODO: verify if a return needed
    // eslint-disable-next-line no-fallthrough
  case 'Selection':
  case 'PortectionRoyale':
    if (item.fieldTypeDetail && item.fieldTypeDetail.startsWith('[')) {
      selectOptions = JSON.parse(item.fieldTypeDetail);
    } else {
      selectOptions = lookup_en[item.fieldTypeDetail];
    }
    selectOptions = selectOptions || [];
    const selectedOption = selectOptions.find((p) => {
      return isStringEqual(p.id, itemValue) || isStringEqual(p.name, itemValue);
    });

    itemValue = selectedOption ? selectedOption.value : item.value;
    return itemValue;
  case 'Award':{
    if (!item.value) {return item.value;}
    const awardArray = item.value.split(' >> ');
    let award  = '', year = '';
    award= awardArray[0];
    year = awardArray[1]==='0'? '': awardArray[1];

    return award + ' ' + year;

  }
  case 'Regions':
    if (!item.value) {return item.value;}
    if (typeof item.value === 'string') {
      const regions = JSON.parse(item.value);
      item.value = regions;
    }
    return item.value.map(p => (
      <span>
        {p.regionsServicedName}
        <br />
      </span>
    ));
  case 'ExpertTopic':
    if (!item.value) {return item.value;}
    if (typeof item.value === 'string') {
      const topic = JSON.parse(item.value);
      item.value = topic;
    }
    return item.value.map(p => (
      <span>
        {p.ExpertTopicName}
        <br />
      </span>
    ));
  case 'FeeException':
    return itemValue;
  case 'SpeakerEvent':
    return itemValue;
  default:
    return itemValue;
  }
}

export default class UserComponent extends Component {
  Item = ({ item, editing }) => {
    if (!item || !item.displayOrder) {return;}
    if (item.fieldType === 'Group') {return <this.GroupHeader item={item} />;}
    if (this.state.hideBlank && this.getItem(item)) {return;}
    return (
      <td>
        <label class="control-label col-sm-5" style={{ 'max-width': '200px' }}>
          {item.dispName}{' '}
          {item.editable ? (
            ''
          ) : (
            <span>
              &nbsp;
              <i class="fa fa-lock" />
            </span>
          )}
        </label>
        <div class="form-text col-sm-5">{getItemValue(item)}</div>
        <div class="col-sm-2 text-right">
          {editing ? <i class="control-label glyphicon glyphicon-pencil" /> : ''}
        </div>
      </td>
    );
  };

  List = ({ state }) => (
    <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover">
      <tbody>
        {state.props
          .filter(p => p.fieldType === 'Group' || p.dispName.toUpperCase().indexOf(state.filter.toUpperCase()) >= 0)
          .map(item => (
            <tr
              style={{ display: 'table-row' }}
              data-displayOrder={item.displayOrder}
              onclick={(e) => {
                if (item.fieldType !== 'Group') {this.run('edit-prop', item, e);}
              }}>
              <this.Item item={item} editing={state.editingItem && item.fieldName === state.editingItem.fieldName} />
            </tr>
          ))}
      </tbody>
    </table>
  );

  state = { filter: '', editingItem: null, mode: 'group', hideBlank: true, props: [] };

  view = (state) => {
    if (!state || !state.props?.length) {return;}
    return (
      <div style={{ width: '500px' }}>
        <div class="row">
          <div class="col-sm-5" >
            <img
              id="usrImage"
              src={state.imageFailed?'/images/user.png':`${window['defaultBasePath']}/users/photo/${state.personId}`}
              style={{ width: '100%' }}
              onerror={() => this.run('image-failed')}
              onclick={e => this.run('edit-photo', e)}
            />
          </div>
          <div class="col-sm-7" style={{ 'white-space': 'normal' }}>
            {(this.isInactive())?<span><i class="fa fa-user-times" />&nbsp;</span>:null}
            <span>{state.uname}</span>
            <h1>{getItemValue(this.getItem('DisplayName'))}</h1>
            <span>{getItemValue(this.getItem('Employeetype'))}</span>
            <br />
            <strong>{getItemValue(this.getItem('PrimaryLocation'))}</strong>
            <br />
            <span>{getItemValue(this.getItem('City'))}</span>, &nbsp;
            <span>{getItemValue(this.getItem('Province'))}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-2 text-left">
            <input class="text-left" type="checkbox" onchange={e => this.run('toggleHidBlank', e)} checked={!state.hideBlank ? 'checked' : null} /> show blank properties
          </div>
          <div class="edit-buttons">
            <input placeholder="Search..." value={state.filter} oninput={e => this.run('search', e)} />{' '}
            <button onclick={() => this.run('A2ZClick')}>A-Z</button>
            <button onclick={() => this.run('GroupsClick')}>Groups</button>
          </div>
        </div>

        <div class="row">
          <button onclick={() => this.run('start-jumpSync')} disabled={(this.getItem('ForceSyncButton') || {}).editable?'':'disabled'}>Jump Sync</button>
          <button onclick={() => this.run('park-email')} disabled={(this.getItem('EmailParkDate') || {}).editable?'':'disabled'}>
            {!this.getItem('EmailParkDate')?.value ? 'Park Email' : 'UnPark Email'}
          </button>
          {
            (this.isInactive())
              ?<button onclick={() => this.run('user-reactivate')} disabled={(this.getItem('EmailParkDate') || {}).editable?'':'disabled'}>Reactivate</button>
              :<button onclick={() => this.run('user-terminate')} disabled={(this.getItem('EmailParkDate') || {}).editable?'':'disabled'}>Terminate</button>
          }
        </div>
        <div  class="row">
          <button onclick={e => this.run('reset-pwd', e)} disabled={(this.getItem('OneTimePassButton') || {}).editable?'':'disabled'}>Reset password</button>
          <button onclick={() => this.run('get-OnetimePwd')} disabled={(this.getItem('OneTimePassButton') || {}).editable?'':'disabled'}>One time password</button>
          &nbsp;<label>{state.oneTimePwd}</label>
        </div>
        <div style={{ 'white-space': 'normal', 'word-wrap': 'break-word' }}>
          <this.List state={state} />
        </div>
      </div>
    );
  };

  update = {
    refresh: async (state, personId) => {
      state.personId = personId;
      if (!state.personId) {return;}

      state.props = await usersApi.getUserPropertyBag(personId);
      state.uname = getItemValue(getPropItem(state, 'UserName'));
      state.companyID = getItemValue(getPropItem(state, 'CompanyID'));

      lookup_en['Locations'] = await locations.getLocationsByCompanyID(state.companyID);
      lookup_en['Locations'].forEach(loc => (loc.value = loc.id + ' - ' +  loc.name));
      lookup_en['Locations'].unshift({ id: '', name: '' });

      state = this.sortGroupwise(state);
      return state;

    },

    A2ZClick: (state) => {
      state.props.sort(function (a, b) {
        return (a.orderA2Z ?? 0) - (b.orderA2Z ?? 0);
      });
      state.props.forEach(item => (item.displayOrder = item.orderA2Z));
      state.mode = 'a-z';
      return state;
    },

    GroupsClick: state => this.sortGroupwise(state),

    'edit-photo': (state, e) => {
      const item = { ...this.getItem('Photo'), value: e.target.src };
      this.run('edit-prop', item, e);
    },

    'edit-prop': (state, item, e) => {

      if (!item.editable) {return;}
      e.preventDefault();

      const panelId = 'prop-edit-' + item.fieldType;
      const editorState = {
        item,
        personId: state.personId,
        panelId,
        caller: this,
        cancel: 'edit-prop-cancel',
        save: 'save-prop',
        delete: 'delete-prop',
        extra:{},
      };

      let comp;
      switch (item.fieldType) {
      case 'CommProg':
        editorState.extra = {
          StartDate: getItemValue(this.getItem('StartDate')),
          EndDate: getItemValue(this.getItem('EndDate')),
          CompanyPersonID: getItemValue(this.getItem('CompanyPersonID')),
        };
        comp = UserPropertycommercialComponent;
        break;
      case 'Specialty':
        comp = UserPropertySpecialityComponent;
        break;
      case 'Selection':
        comp = PropEditorSelectionComponent;
        break;
      case 'DateStr':
        comp = PropEditorDateComponent;
        break;
      case 'UserDateStr':
        editorState.extra = {
          StartDate: getItemValue(this.getItem('StartDate')),
          EndDate: getItemValue(this.getItem('EndDate')),
        };
        comp = UserPropertyDateComponent;
        break;
      case 'TMDateStr':
        if(getItemValue(this.getItem('TeamName'))===''){return;}
        editorState.extra = {
          TStartDate: getItemValue(this.getItem('TStartDate')),
          TEndDate: getItemValue(this.getItem('TEndDate')),
          StartDate: getItemValue(this.getItem('StartDate')),
          EndDate: getItemValue(this.getItem('EndDate')),
          CompanyPersonID: getItemValue(this.getItem('CompanyPersonID')),
        };

        comp = UserPropertyTeamDateComponent;
        break;
      case 'Regions':
        comp = PropEditorRegionsComponent;
        editorState.extra = { province: getItemValue(this.getItem('Province')) };
        break;
      case 'ExpertTopic':
        comp = PropEditorExpertTopicComponent;
        break;
      case 'Phone':
        comp = UserPropertyPhoneComponent;
        break;
      case 'Award':
        comp = UserPropertyAwardComponent;
        break;
      case 'SocNet':
        comp = UserPropertySocNetComponent;
        break;
      case 'Photo':
        comp = UserPropertyPhotoComponent;
        break;
      case 'FeeException':
        comp = UserPropertyFeeExceptionComponent;
        break;
      case 'IreOverride':
        comp = UserPropertyIreOverrideComponent;
        break;
      case 'PortectionRoyale':
        editorState.extra = {
          StartDate: getItemValue(this.getItem('StartDate')),
          EndDate: getItemValue(this.getItem('EndDate')),
          CompanyPersonID: getItemValue(this.getItem('CompanyPersonID')),
        };
        comp = UserPropertyProtectionRoyaleComponent;
        break;
      case 'AuditLog':
        comp = UserPropertyAuditLogComponent;
        break;

      case 'SpeakerEvent':
        comp = UserPropertySpeakerEventComponent;
        break;

      case 'Username':
        comp = UserPropertyUsernameComponent;
        break;

      default:
        comp = PropEditorTextComponent;
        break;
      }

      state.editingItem = item;
      app.run('#add-panel', { id: panelId, title: item.dispName, Component: comp, state: editorState, level: 4 });
    },

    'save-prop': async (state, item, panelId, newVal) => {
      try{
        const errDiv = (document.getElementById('inpTextErrMsg') as HTMLDivElement);
        if(errDiv){
          errDiv.innerHTML = '';
        }
        let result;
        if (panelId === 'prop-edit-Regions') {
          result = await usersApi.postUserAreas(state[idFieldName], newVal);
        } else if (panelId === 'prop-edit-ExpertTopic') {
          result = await usersApi.postExpertTopic(state[idFieldName], newVal);
        } else {
          result = await usersApi.upsertUserProperty(state[idFieldName], { prop: item, newValue: newVal });
        }

        showSaveStatusMessage(result> 0?'user':'');
        if (result) {
          if (item.multiValue && item.value === '') {
            state.props.splice(state.props.indexOf(item) + 1, 0, { ...item });
          }
          item.value = newVal;
          this.run('edit-prop-cancel', panelId);

          if (item.fieldName === 'Employeetype') {
            const sellingIndObj = state.props.find(obj => obj.fieldName === 'SellingInd');
            sellingIndObj.value = '3';

            const displayOnSearchIndObj = state.props.find(obj => obj.fieldName === 'DisplayOnSearchInd');
            displayOnSearchIndObj.value = '4';

            switch (item.value) {
            case '1': {
            //--Licensed Assistant 1
              sellingIndObj.value = '1';
              displayOnSearchIndObj.value = '1';
              break;
            }
            case '2': {
            //--Broker Manager 2
              sellingIndObj.value = '0';
              displayOnSearchIndObj.value = '1';
              break;
            }
            case '10': {
            //--Broker Manager - Selling 10
              sellingIndObj.value = '1';
              displayOnSearchIndObj.value = '1';
              break;
            }
            case '6': {
            //--Finance Staff - 6
              sellingIndObj.value = '0';
              displayOnSearchIndObj.value = '0';
              break;
            }
            case '9': {
            //--Broker Owner - 9
              sellingIndObj.value = '0';
              displayOnSearchIndObj.value = '1';
              break;
            }
            case '7': {
            //--Broker Owner - Selling - 7
              sellingIndObj.value = '1';
              displayOnSearchIndObj.value = '1';
              break;
            }
            case '8': {
            //--Agent / Sales Representative - 8
              sellingIndObj.value = '1';
              displayOnSearchIndObj.value = '1';
              break;
            }
            case '11': {
            //--Unlicensed Assistant - 11
              sellingIndObj.value = '0';
              displayOnSearchIndObj.value = '0';
              break;
            }
            case '3': {
            //--Administration - 3
              sellingIndObj.value = '0';
              displayOnSearchIndObj.value = '0';
              break;
            }
            default:
            }
          }
        }else{
          if (item.fieldName ==='Back Office No.'){
            errDiv.innerHTML ='Duplicate Back Office Number Found.';
          }
        }
      }catch(err){
        showSaveStatusMessage();
        const errMsg = await err.json();
        const errDiv = (document.getElementById('inpTextErrMsg') as HTMLDivElement);

        if(errDiv){
          errDiv.innerHTML =  errMsg.exceptionMessage.split('\n', 1)[0];
        }
      }

      return state;
    },

    'delete-prop': async (state, item, panelId) => {
      const result = await usersApi.deleteUserProperty(state.personId, item);
      showSaveStatusMessage('user');
      if (result) {
        if (item.multiValue) {
          state.props.splice(state.props.indexOf(item), 1);
        } else {
          item.value = '';
        }
        this.run('edit-prop-cancel', panelId);
      }
    },

    'edit-prop-cancel': (state, id) => {
      state.editingItem = null;
      app.run('#clear-panel', id);
      return state;
    },

    'image-failed': (state) => {
      if (!state.imageFailed) {return { ...state, imageFailed: true };}
    },

    cancel: (state, item, e) => ({ ...state, editingItem: null, e: e.preventDefault() }),

    toogleGroup: (state, e) => {
      e.preventDefault();
      const groupId = parseInt(e.target.dataset.displayOrder);
      const allTableRows = document.getElementById('tblProp').querySelectorAll('tr');
      for (let i = 0; i < allTableRows.length; i++) {
        const tr = allTableRows[i] as HTMLElement;
        const sortOrder = parseInt(tr.dataset.displayOrder);
        if (sortOrder > groupId && sortOrder < groupId + 500) {
          tr.style.display = tr.style.display === 'none' ? 'table-row' : 'none';
        }
      }
    },

    search: (state, e) => ({ ...state, filter: e.target.value }),

    toggleHidBlank: (state, e) => ({ ...state, hideBlank: !e.target.checked }),

    'get-OnetimePwd': async (state) => {
      const oneTimePwd = await usersApi.getOneTimePwd(state.personId);
      return { ...state, oneTimePwd };
    },

    'reset-pwd': (state, e) => {
      e.preventDefault();
      const panelId = 'prop-edit-reset-pwd';
      app.run('#add-panel', {
        id: panelId,
        title: 'Reset Password',
        Component: UserPropertyPasswordComponent,
        state: { personId: state.personId, panelId, caller: this, cancel: 'edit-prop-cancel' },
        level: 4,
      });
      return state;
    },

    'start-jumpSync': async (state) => {
      await usersApi.initiateForceSync(state.personId);
      showSaveStatusMessage('Jump Sync');
    },

    'park-email': async (state) => {
      const park = (this.getItem('EmailParkDate') || {}).value === '';
      const result = await usersApi.parkEmail(state.personId, park);
      if (result) {this.getItem('EmailParkDate').value = park ? 'dd' : '';}
      showSaveStatusMessage('park-email');
      return state;
    },

    'user-terminate': (state) => {
      const employeeType = this.getItem('Employeetype').value;
      const isAgent = employeeType === 1 || employeeType === 8;
      app.run('#add-panel', {
        id: 'userTerminate',
        title: 'Terminate: ' + state.uname,
        Component: UserTerminate,
        level: 3,
        state: {
          caller: this,
          panelId: 'userTerminate',
          personId: state.personId,
          isAgent,
          companyID: state.companyID,
          startDate: moment(state.props.find(p => p.fieldName === 'StartDate').value, 'YYYY-MM-DD').format('DD-MMM-YYYY')
        },
      });
    },

    'user-reactivate': async (state) => {

      const profile = await usersApi.getReactivateProfile(getItemValue(this.getItem('EMailAddress')));
      const locStr = getItemValue(this.getItem('PrimaryLocation'));
      profile.primaryLocationID = locStr.substring(0, locStr.indexOf(' '));
      const locationOptions = !profile.companyID? [] : await locations.getLocationsByCompanyID(profile.companyID);
      const brokerageOptions = await companies.getOpenCompanies();

      app.run('#add-panel', {
        id: 'userReactivate',
        title: 'Reactivate: ' + state.uname,
        Component: UserReactivate,
        level: 3,
        state: { caller: this, panelId: 'userReactivate', personId: state.personId, profile, locationOptions, brokerageOptions }
      });
    },

    '#sub-panel-done': (state, panelId) => {
      this.run('refresh');
      app.run('#clear-panel', panelId);
    },
  };

  getItem = fieldName => this.state.props.find(p => p.fieldName === fieldName);

  isInactive(): boolean {
    const endDateStr = getItemValue(this.getItem('EndDate'));
    if (endDateStr) {
      const endDate = new Date(endDateStr);
      const date = new Date();
      return date > endDate;
    }
    return false;
  }

  GroupHeader = ({ item }) => (
    <td>
      <button class="col-sm-12" data-displayOrder={item.displayOrder} onclick={e => this.run('toogleGroup', e)}>
        {item.dispName}
      </button>
    </td>
  );

  mounted = ({ state }) => {
    this.run('refresh', state.personId);
  };

  sortGroupwise = (state) => {
    state.props.sort(function (a, b) {
      return(a.orderScheme1 ?? 0) - (b.orderScheme1 ?? 0);
    });
    state.props.forEach(item => (item.displayOrder = item.orderScheme1));
    state.mode = 'group';
    return state;
  }
}
